import MUITab from '@mui/material/Tab';
import { TabProps } from './tab-props.type';

export const Tab: React.FC<TabProps> = (props) => {
  const { children, ...tabsBaseProps } = props;
  return <MUITab {...tabsBaseProps}>{children}</MUITab>;
};
